import { createContext, useContext } from 'react';
import type { DatasetContextType } from './types';

export const DatasetContext = createContext<DatasetContextType | undefined>(
  undefined,
);

export const useDatasetContext = (): DatasetContextType => {
  const context = useContext(DatasetContext);
  if (!context) {
    throw new Error('useDatasetContext must be used within a DatasetContext');
  }
  return context;
};
